import React from 'react';
import RootElement from './src/components/RootElement';

export const shouldUpdateScroll = () => [0, 0];

export const wrapPageElement = ({ element }) => {
  return <RootElement>{element}</RootElement>;
};
